import { Box } from '@mui/material';
import {
  HorizontalLine,
  StyledActionLink,
} from 'components/create-account/create-account.styles';
import { useTranslation } from 'react-i18next';

const CreateAccountPrompt = ({
  onClick,
  'data-testid': dataTestId = 'CreateAccountPrompt.Link.CreateAccount',
}) => {
  const { t } = useTranslation();

  return (
    <>
      <HorizontalLine />
      <Box display="flex" alignItems="center" justifyContent="center">
        {t('register.label.dontHaveAccount')}{' '}
        <StyledActionLink onClick={onClick} data-testid={dataTestId}>
          {t('register.label.createOneNow')}
        </StyledActionLink>
      </Box>
    </>
  );
};

export default CreateAccountPrompt;
